<template>
  <div class="hello">
    <div class="logo">
      <div class="logoI">
        <!-- 添加汉堡菜单按钮 -->
        <div class="hamburger-menu" @click="toggleMenu($event)">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <img src="../assets/top2.png" class="logo-image">
      </div>
    </div>
    
    <!-- 抽屉菜单 -->
    <div class="drawer-menu" :class="{'drawer-menu-open': menuOpen}" @click.stop>
      <div class="drawer-menu-header">
        <div class="drawer-close" @click="toggleMenu($event)">×</div>
      </div>
      <ul class="drawer-menu-items">
        <li @click="zero()" :class="{'drawer-active': activeIndex === 0}">
          <a class="drawer-menu-link">首页</a>
        </li>
        <li @click="One()" :class="{'drawer-active': activeIndex === 1}">
          <a class="drawer-menu-link">集团概况</a>
        </li>
        <li @click="Two()" :class="{'drawer-active': activeIndex === 2}">
          <a class="drawer-menu-link">集团动态</a>
        </li>
        <li @click="Three()" :class="{'drawer-active': activeIndex === 3}">
          <a class="drawer-menu-link">党建之家</a>
        </li>
        <li @click="five()" :class="{'drawer-active': activeIndex === 4}">
          <a class="drawer-menu-link">企业文化</a>
        </li>
        <li @click="six()" :class="{'drawer-active': activeIndex === 5}">
          <a class="drawer-menu-link">联系我们</a>
        </li>
      </ul>
    </div>
    <!-- 添加遮罩层，用于点击关闭菜单，直接使用closeMenu方法 -->
    <div class="drawer-overlay" v-if="menuOpen" @click="closeMenu"></div>
    
    <div class="navChange" :class="{ 'nav-fixed': isNavFixed }">
      <div class="bodyAll">
        <ul>
          <li class="nav-item" :class="{ 'active': activeIndex === 0 }" @click="zero()">
            <div class="menu-container">
              <a class="menu-link">首页</a>
              <div class="hover-effect"></div>
            </div>
          </li>
          <li class="nav-item" :class="{ 'active': activeIndex === 1 }" @click="One()">
            <div class="menu-container">
              <a class="menu-link">集团概况</a>
              <div class="hover-effect"></div>
            </div>
          </li>
          <li class="nav-item" :class="{ 'active': activeIndex === 2 }" @click="Two()">
            <div class="menu-container">
              <a class="menu-link">集团动态</a>
              <div class="hover-effect"></div>
            </div>
          </li>
          <li class="nav-item" :class="{ 'active': activeIndex === 3 }" @click="Three()">
            <div class="menu-container">
              <a class="menu-link">党建之家</a>
              <div class="hover-effect"></div>
            </div>
          </li>
          <li class="nav-item" :class="{ 'active': activeIndex === 4 }" @click="five()">
            <div class="menu-container">
              <a class="menu-link">企业文化</a>
              <div class="hover-effect"></div>
            </div>
          </li>
          <li class="nav-item" :class="{ 'active': activeIndex === 5 }" @click="six()">
            <div class="menu-container">
              <a class="menu-link">联系我们</a>
              <div class="hover-effect"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Top',
  data() {
    return {
      activeIndex: 0,
      isNavFixed: false,
      menuOpen: false // 添加控制菜单打开状态的变量
    }
  },
  created() {
    // 在创建组件时就设置activeIndex，确保不会默认选中党建之家
    this.setActiveByRoute();
  },
  mounted() {
    // 根据当前路由设置活跃菜单项
    this.setActiveByRoute();
    
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    // 移除滚动监听
    window.removeEventListener('scroll', this.handleScroll);
    
    // 移除点击外部关闭抽屉菜单的事件
    document.removeEventListener('click', this.handleOutsideClick);
  },
  methods: {
    // 切换菜单显示状态
    toggleMenu(event) {
      if (event) {
        event.stopPropagation();
      }
      this.menuOpen = !this.menuOpen;
      
      // 打开菜单时禁止滚动
      if (this.menuOpen) {
        document.body.style.overflow = 'hidden';
        // 添加点击外部关闭抽屉菜单的事件
        setTimeout(() => {
          document.addEventListener('click', this.handleOutsideClick);
        }, 10);
      } else {
        document.body.style.overflow = '';
        // 移除点击外部关闭抽屉菜单的事件
        document.removeEventListener('click', this.handleOutsideClick);
      }
    },
    // 处理点击外部关闭菜单
    handleOutsideClick(event) {
      const drawer = document.querySelector('.drawer-menu');
      const hamburger = document.querySelector('.hamburger-menu');
      
      // 确保不是抽屉菜单内部的点击
      if (drawer && 
          !drawer.contains(event.target) && 
          hamburger && 
          !hamburger.contains(event.target)) {
        // 关闭菜单
        if (this.menuOpen) {
          this.menuOpen = false;
          document.body.style.overflow = '';
          document.removeEventListener('click', this.handleOutsideClick);
        }
      }
    },
    setActiveByRoute() {
      const path = this.$route.path;
      
      // 使用精确匹配，避免路径包含问题
      switch(path) {
        case '/':
        case '/HelloWorld':
          this.activeIndex = 0;
          break;
        case '/Survey':
        this.activeIndex = 1;
          break;
        case '/State':
        this.activeIndex = 2;
          break;
        case '/Party':
        this.activeIndex = 3;
          break;
        case '/Culture':
        this.activeIndex = 4;
          break;
        case '/Relation':
        this.activeIndex = 5;
          break;
        default:
          this.activeIndex = 0; // 默认选中首页
      }
      
      // 控制台输出当前路径和选中的菜单索引，便于调试
      console.log('Current path:', path, 'activeIndex:', this.activeIndex);
    },
    handleScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      this.isNavFixed = scrollTop > 150;
    },
    zero() {
      this.activeIndex = 0;
      this.menuOpen = false; // 点击导航后关闭抽屉菜单
      this.$router.push({
        name: 'HelloWorld',
      });
    },
    One() {
      this.activeIndex = 1;
      this.menuOpen = false; // 点击导航后关闭抽屉菜单
      this.$router.push({
        name: 'Survey',
        params: {
          num: 1
        }
      });
    },
    Two() {
      this.activeIndex = 2;
      this.menuOpen = false; // 点击导航后关闭抽屉菜单
      this.$router.push({
        name: 'State',
        params: {
          num: 1
        }
      });
    },
    Three() {
      this.activeIndex = 3;
      this.menuOpen = false; // 点击导航后关闭抽屉菜单
      this.$router.push({
        name: 'Party',
        params: {
          num: 1
        }
      });
    },
    five() {
      this.activeIndex = 4;
      this.menuOpen = false; // 点击导航后关闭抽屉菜单
      this.$router.push({
        name: 'Culture',
        params: {
          num: 1
        }
      });
    },
    six() {
      this.activeIndex = 5;
      this.menuOpen = false; // 点击导航后关闭抽屉菜单
      this.$router.push({
        name: 'Relation',
        params: {
          num: 1
        }
      });
    },
    // 直接关闭菜单的方法
    closeMenu() {
      this.menuOpen = false;
      document.body.style.overflow = '';
      document.removeEventListener('click', this.handleOutsideClick);
    },
  }
}
</script>

<style scoped>
/* 主体 Logo 区域 */
.logo {
  background: #0c4da2; /* 更改为深蓝色 */
  min-height: 150px;
  width: 100%;
  position: relative;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.2);
}

.logoI {
  width: 100%;
  max-width: 1400px;
  margin: auto;
  display: flex;
  align-items: center;
  height: 150px;
  position: relative; /* 为汉堡菜单提供定位上下文 */
  padding: 0 15px; /* 添加内边距 */
}

.logo-image {
  padding-left: 60px; /* 增加左侧内边距，为汉堡菜单留出空间 */
  transition: transform 0.3s ease;
  max-width: 100%;
  height: auto;
}

.logo-image:hover {
  transform: scale(1.03);
  filter: brightness(1.1);
}

/* 汉堡菜单按钮 */
.hamburger-menu {
  display: none; /* 默认隐藏 */
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  width: 30px;
  height: 24px;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  z-index: 1001;
}

.hamburger-menu span {
  display: block;
  height: 3px;
  width: 100%;
  background-color: #fff;
  border-radius: 3px;
  transition: all 0.3s ease;
}

/* 抽屉菜单样式 */
.drawer-menu {
  position: fixed;
  top: 0;
  left: -280px; /* 稍微缩小以匹配宽度 */
  width: 260px; /* 调整宽度 */
  height: 100vh;
  background: linear-gradient(135deg, #0a3d82, #1e5dbd);
  z-index: 1010;
  transition: left 0.3s ease;
  overflow-y: auto;
  box-shadow: 5px 0 15px rgba(0, 0, 0, 0.2);
}

.drawer-menu-open {
  left: 0;
}

.drawer-menu-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end; /* 改为右对齐 */
  padding: 0 15px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.drawer-close {
  font-size: 30px;
  color: #fff;
  cursor: pointer;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background 0.3s ease;
}

.drawer-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.drawer-menu-items {
  list-style: none;
  padding: 20px 0;
  margin: 0;
}

.drawer-menu-items li {
  position: relative;
  padding: 0;
  margin: 10px 0;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.drawer-menu-items li:last-child {
  border-bottom: none;
}

.drawer-menu-link {
  display: block;
  padding: 15px 20px;
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  border-right: 4px solid transparent;
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 1px;
  position: relative;
}

.drawer-menu-items .drawer-active .drawer-menu-link {
  background: rgba(255, 255, 255, 0.1);
  border-right: 4px solid #76b6ff;
  padding-right: 25px;
  color: #76b6ff;
}

.drawer-menu-link:hover, .drawer-menu-link:active {
  background: rgba(255, 255, 255, 0.1);
  border-right: 4px solid #76b6ff;
  padding-right: 25px;
}

.drawer-menu-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  right: 20px;
  width: 0;
  height: 2px;
  background: #76b6ff;
  transition: width 0.3s ease;
}

.drawer-menu-link:hover::after {
  width: calc(100% - 40px);
}

/* 导航区域 */
.navChange {
  width: 100%;
  margin: auto;
  background: linear-gradient(to right, #0a3d82, #1e5dbd, #0a3d82); /* 蓝色渐变背景 */
  display: flex;
  justify-content: center;
  position: relative;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  z-index: 100;
}

.nav-fixed {
  position: fixed;
  top: 0;
  left: 0;
  animation: slideDown 0.3s forwards;
  box-shadow: 0 3px 20px rgba(0, 0, 0, 0.3);
}

@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.bodyAll {
  width: 100%;
  max-width: 1300px;
  margin: auto;
}

.bodyAll ul {
  list-style: none;
  display: flex;
  width: 100%;
  padding: 0;
  margin: 0;
  height: 60px;
  justify-content: space-around;
}

/* 导航项 */
.nav-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  overflow: hidden;
}

.nav-item::before {
  content: '';
  position: absolute;
  top: -100%;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  transition: all 0.5s ease;
  z-index: 0;
}

.nav-item:hover::before {
  top: 0;
}

.menu-container {
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  z-index: 1;
}

.hover-effect {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background: #fff;
  transform: translateX(-100%);
  transition: transform 0.3s ease;
}

.nav-item:hover .hover-effect {
  transform: translateX(0);
}

.nav-item.active .hover-effect {
  transform: translateX(0);
  background: #76b6ff;
}

.nav-item.active {
  background: rgba(255, 255, 255, 0.1);
}

.menu-link {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 500;
  text-decoration: none;
  padding: 0 40px;
  height: 100%;
  transition: all 0.3s ease;
  z-index: 2;
  position: relative;
}

.nav-item:hover .menu-link {
  transform: translateY(-3px);
  text-shadow: 0 3px 5px rgba(0, 0, 0, 0.2);
}

.nav-item.active .menu-link {
  color: #76b6ff;
  font-weight: bold;
}

.nav-item:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 30%;
  height: 40%;
  width: 1px;
  background: rgba(255, 255, 255, 0.3);
}

/* 响应式样式 */
@media screen and (max-width: 992px) {
  .menu-link {
    padding: 0 20px;
    font-size: 16px;
  }
  
  .nav-item:hover .menu-link {
    transform: translateY(-2px);
  }
  
  .bodyAll {
    padding: 0 15px; /* 添加内边距防止溢出 */
  }
}

@media screen and (max-width: 768px) {
  /* 显示汉堡菜单，隐藏顶部导航 */
  .hamburger-menu {
    display: flex;
    z-index: 1010; /* 确保汉堡菜单在最上层 */
  }
  
  .navChange {
    display: none;
  }
  
  .logoI {
    justify-content: center;
    padding: 0 15px; /* 确保有足够的内边距 */
  }
  
  .logo-image {
    max-width: 80%;
    padding-left: 40px; /* 减小左侧内边距 */
  }
  
  .hello {
    width: 100%;
    overflow-x: hidden; /* 防止水平溢出 */
  }
  
  .drawer-menu {
    width: 240px; /* 移动端更窄一点 */
  }
  
  .drawer-menu-link {
    padding: 15px;
    font-size: 16px;
  }
  
  /* 修复移动端100vh问题 */
  .drawer-menu, .drawer-overlay {
    height: 100%; 
    height: -webkit-fill-available;
  }
}

@media screen and (max-width: 576px) {
  .logo {
    min-height: 100px;
  }
  
  .logoI {
    height: 100px;
  }
  
  .hamburger-menu {
    left: 15px;
  }
  
  .logo-image {
    padding-left: 30px; /* 进一步减小左侧内边距 */
  }
  
  .drawer-menu {
    width: 230px; /* 更窄一点 */
  }
  
  .drawer-menu-link {
    padding: 12px 15px;
    font-size: 15px;
  }
  
  .drawer-close {
    width: 35px;
    height: 35px;
  }
  
  /* 修复移动端宽度溢出问题 */
  body {
    width: 100%;
    overflow-x: hidden;
  }
}

@media screen and (max-width: 375px) {
  .drawer-menu {
    width: 220px; /* 最小屏幕下更窄 */
  }
}

/* 添加遮罩层样式 */
.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1005;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent; /* 移除移动端点击高亮 */
}
</style>



// WEBPACK FOOTER //
// src/components/Top.vue